import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';

import OpsLogin from './pages/OpsLogin/OpsLogin';
import OpsDashboard from './pages/OpsDashboard/OpsDashboard';

const OpsSistemaDisco = lazy(() => import('./pages/OpsSistemaDisco/OpsSistemaDisco.jsx'));

function AppContent() {
  return (
    <Routes>
      <Route path="/ops/login" element={<OpsLogin />} />
      <Route path="/ops/dashboard" element={<OpsDashboard />} />
      <Route
        path="/ops/sistema"
        element={
          <Suspense fallback={<div>Cargando...</div>}>
            <OpsSistemaDisco />
          </Suspense>
        }
      />
      <Route path="*" element={<OpsLogin />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;